import {ClientAddress, ClientAddressFields} from "../../types/client/clientData";

export const AddressFormatter = {
    toFullAddress: (address: ClientAddress): string => {
        const streetWithNumber = [address?.[ClientAddressFields.Street], address?.[ClientAddressFields.StreetNumber]]
            .filter(e => !!e).join(' ')
        const floor = address?.[ClientAddressFields.Floor]
            ? `Piso: ${address[ClientAddressFields.Floor]}`
            : ''
        const apartment = address?.[ClientAddressFields.Apartment]
            ? `Dept.: ${address[ClientAddressFields.Apartment]}`
            : ''
        const postalCode = address?.[ClientAddressFields.PostalCode]
            ? `(${address[ClientAddressFields.PostalCode]})`
            : ''
        const geoData = [floor, apartment, postalCode,
            address?.[ClientAddressFields.MunicipalityDesc], address?.[ClientAddressFields.ProvinceDesc]]
            .filter(e => !!e).join(' - ')
        
        return [streetWithNumber, geoData]
            .filter(e => !!e).join(', ')
    },
}